var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinNumber = function SvgCoinNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    className: "coinNumber_svg__coin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.555 2.45a50 50 0 0 0-32.11 63 50 50 0 0 0 63 32.11 50 50 0 0 0 32.11-63 50 50 0 0 0-63-32.11m1.544 4.755a45 45 0 0 1 56.7 28.9 45 45 0 0 1-28.899 56.7 45 45 0 0 1-56.7-28.9 45 45 0 0 1 28.9-56.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 7.5A42.5 42.5 0 0 0 7.5 50 42.5 42.5 0 0 0 50 92.5 42.5 42.5 0 0 0 92.5 50 42.5 42.5 0 0 0 50 7.5m-2.313 11.808h6.282v55.298h10.848v6.085H35.184v-6.085H46.3l-.068-20.704-.068-20.704-5.49-.072-5.49-.071v-5.28l1.389-.01c3.394-.023 7.242-1.157 8.765-2.584.974-.914 1.964-3.009 2.18-4.617z"
  }))));
};
export default SvgCoinNumber;